import script from "./blacklist.vue?vue&type=script&setup=true&lang=js"
export * from "./blacklist.vue?vue&type=script&setup=true&lang=js"

import "./blacklist.vue?vue&type=style&index=0&id=0c25132e&scoped=true&lang=less"

import exportComponent from "/home/opt/gitlab-runner/web_artemisads_repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0c25132e"]])

export default __exports__